'use client'

import {tv} from 'tailwind-variants'
import {SocialProofContent} from './_components/SocialProofContent'
import type {SocialProofContentProps} from './_components/SocialProofContent/types'

export type HgSocialProofListProps = {
  items:
    | [SocialProofContentProps]
    | [SocialProofContentProps, SocialProofContentProps]
    | [SocialProofContentProps, SocialProofContentProps, SocialProofContentProps]
}

const socialProofList = tv({
  slots: {
    container: '',
    itemsContainer: 'grid w-full gap-s2 sm:gap-s4',
    itemContainer: 'flex h-[57px] border-l border-border-subdued pl-s2',
  },
  variants: {
    itemCount: {
      1: {
        itemsContainer: 'grid-cols-1',
      },
      2: {
        itemsContainer: 'grid-cols-2',
      },
      3: {
        itemsContainer: 'grid-cols-3',
      },
    },
  },
})

export function HgSocialProofList({items}: HgSocialProofListProps) {
  const {container, itemsContainer, itemContainer} = socialProofList({
    itemCount: items.length,
  })

  return (
    <div className={container()}>
      <div className={itemsContainer()}>
        {items.map((item, index) => (
          <div key={`${item.type}-${index}`} className={itemContainer()}>
            <SocialProofContent {...item} />
          </div>
        ))}
      </div>
    </div>
  )
}
